import { TelefoneModel } from './TelefoneModel';
import { DadosClienteModel } from './DadosClienteModel';

export class DadosCliente implements DadosClienteModel {
  cpfCnpj: string;
  email: string;
  nome: string;
  telefones: TelefoneModel[];
  tipo: string;

  constructor() {
    this.cpfCnpj = '';
    this.email = '';
    this.nome = '';
    this.telefones = [];
    this.tipo = '';
  }

}
